import React from 'react'
import styled from 'styled-components'
import { StaticAssetsUrl } from 'redux/config/services/Constants'
import DrawerView from 'core-system/Drawer/Drawer'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import PrimaryButton from 'core-system/Button/PrimaryButton'

const ChildrenContainer = styled.div`
  padding: 2.5rem 1.5rem;
  height: 100%;
`

const ButtonsContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`

interface ButtonProps {
  text: string
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}

interface OnboardingTasksDrawerProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  primaryButton?: ButtonProps
  secondaryButton?: ButtonProps
}

const OnboardingTasksDrawer = ({
  isOpen,
  onClose,
  children,
  primaryButton,
  secondaryButton,
}: OnboardingTasksDrawerProps) => (
  <DrawerView isOpen={isOpen} onClose={onClose}>
    <img src={`${StaticAssetsUrl}/programs/program_drawer_top.svg`} alt='top' />
    <ChildrenContainer>
      {children}
      <ButtonsContainer>
        {secondaryButton && (
          <SecondaryButton
            onClick={secondaryButton.onClick}
            disabled={secondaryButton.disabled}
            loading={secondaryButton.loading}
          >
            {secondaryButton.text}
          </SecondaryButton>
        )}
        {primaryButton && (
          <PrimaryButton
            onClick={primaryButton.onClick}
            disabled={primaryButton.disabled}
            loading={primaryButton.loading}
          >
            {primaryButton.text}
          </PrimaryButton>
        )}
      </ButtonsContainer>
    </ChildrenContainer>
  </DrawerView>
)

export default React.memo(OnboardingTasksDrawer)
